import React, { useMemo, useState } from "react";
import { ClickAwayListener, Popper } from "@mui/material";
import { flexRender } from "@tanstack/react-table"
import { TrendingUp, TrendingDown } from "lucide-react";
import CellContainer from "../cellContainer";
import PricingGuidanceCard from "../../BulkReprice/PricingGuidanceCard";
import { cn } from "../../../utils/utils";

const PositionCell = ({ cell }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const guidanceData = useMemo(() => {
    const source = cell?.row?.original ?? {};

    return {
      confidence: source["Confidence"],
      bandLow: source["Band Low"],
      bandHigh: source["Band High"],
      suggested: source["Suggested Price"],
      ask: source["$/Ct"],
      bestComp: source["Best Compition Price"],
      direction: source["Direction"],
      position: source["Position"],
      ppcPredicted: source["PPC Predicted"],
      ppcPredictedFrom: source["PPC Predicted From"],
      ppcPredictedTo: source["PPC Predicted To"],
    };
  }, [cell?.row?.original]);

  const hasGuidance = useMemo(() => {
      const { bandLow, bandHigh, suggested, position } = guidanceData;
      return [bandLow, bandHigh, suggested, position].some(
        (value) => value !== null && value !== undefined && value !== ""
      );
    }, [guidanceData]);

  const handleMouseEnter = (event) => {
    if (!hasGuidance) return;
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const positionMeta = useMemo(() => {
    const value = cell.getValue();
    const source = cell?.row?.original ?? {};

    const parseNumber = (input) => {
      if (input === null || input === undefined || input === "") return null;
      const numeric = Number(input);
      return Number.isFinite(numeric) ? numeric : null;
    };

    
    const pct = parseNumber(source["Position"]);

    if (
      pct === null
    ) {
      return {
        label: value ?? "-",
        colorClass: "text-gray-700 border-gray-300 bg-gray-50",
        Icon: null,
      };
    }

    

    if (!Number.isFinite(pct) || Math.abs(pct) == 0) {
      return {
        label: "Inside",
        colorClass: "text-green-700 border-green-300 bg-green-50",
        Icon: null,
      };
    }

    if (pct > 0) {
      return {
        label: `${pct.toFixed(0)}%`,
        colorClass: "text-amber-700 border-amber-300 bg-amber-50",
        Icon: TrendingUp,
      };
    }

    return {
      label: `${Math.abs(pct).toFixed(0)}%`,
      colorClass: "text-red-600 border-red-300 bg-red-50",
      Icon: TrendingDown,
    };
  }, [cell]);

  return (
    <>
      <Popper
        open={Boolean(anchorEl) && hasGuidance}
        anchorEl={anchorEl}
        placement="bottom"
        style={{ zIndex: 1000 }}
        
      >
        <ClickAwayListener onClickAway={handleClose}>
          <div className="w-full bg-white border border-[#cbcbcb] rounded-xl px-1 py-2 shadow-md">
            <PricingGuidanceCard band={guidanceData} />
          </div>
        </ClickAwayListener>
      </Popper>
      <td
        key={cell.id}
        className="h-10"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleClose}
      >
        <CellContainer className="text-[0.6rem] font-medium mt-1 justify-end px-3 text-center">
          <p
            className={cn(
              "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[0.6rem] font-semibold",
              positionMeta.colorClass
            )}
          >
            {positionMeta.Icon ? (
              <positionMeta.Icon size={12} strokeWidth={2} />
            ) : null}
            {positionMeta.label ?? flexRender(cell.column.columnDef.cell, cell.getContext())}
          </p>
        </CellContainer>
      </td>
    </>
  );
};

export default PositionCell;

